import { render, staticRenderFns } from "./GenderDistributionChart.vue?vue&type=template&id=6eb2c756&scoped=true"
import script from "./GenderDistributionChart.vue?vue&type=script&lang=js"
export * from "./GenderDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./GenderDistributionChart.vue?vue&type=style&index=0&id=6eb2c756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb2c756",
  null
  
)

export default component.exports